import { Component, OnInit, AfterViewInit, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CountryManagementService } from '../../../service/country-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { FocusInputType, KeyValues10, KeyValues3, KeyValues5, KeyValueSet, LocalService, MemberWrapper, NumericConfig, Status, TriggeredEvent } from '../../../service/local.service';
import { ProfileManagementService } from '../../../service/profile-management.service';
import { MessageComponent } from '../message/message.component';

@Component({
  selector: 'app-create-account',
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.scss']
})
export class CreateAccountComponent implements OnInit, AfterViewInit {
  @ViewChild('content_create_account') content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();
  @Input() btnIdToTriggerWhileClose: string = '';

  @Input() id = ''; @Input() ctryCode = ''; isOtpVerifiedForEdit = null; phoneNumberBeforeEdit = '';
  @Input() BusinessId = ''; selectedContact: KeyValues5; refMember: KeyValueSet;
  @Input() PhoneNumber: string = ''; isSetFromLogin = false; isAlphaNumericPostalCode = false;
  htmlId: string = '';
  wrapper: MemberWrapper = {
    localLocations: { v3: '', v2: '', v1: '' } as KeyValues3,
    content: null,
    languageNames: null,
    languageNamesShort: null
  }
  mandatoryLanguages = [];
  isAgreementClicked: boolean = false;
  states: any; districts: any; constituencies: any;
  lstSectionConfigKeys: string[] = ["create_account", "local_locations", "edit_additional_details"];
  message: string = ''; isRedAlert: boolean = true;
  isAddNewAddress: boolean = false; addressTitle: string = 'Delivery Address'; address: string = '';

  elementIds: any;
  numericConfig: NumericConfig = {} as NumericConfig;

  constructor(private offcanvasService: NgbOffcanvas, public localService: LocalService, private languageManagementService: LanguageManagementService, public countryManagementService: CountryManagementService, public profileManagementService: ProfileManagementService, private modalService: NgbModal) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      ph_num: 'ph_num_' + this.htmlId,
      name: 'create_account_name_' + this.htmlId,
      name_short: 'create_account_name_name_short' + this.htmlId,
      state: 'local_location_state_' + this.htmlId,
      district: 'local_location_district_' + this.htmlId,
      constituency: 'local_location_constituency_' + this.htmlId,
      postal: 'create_account_postal_' + this.htmlId,
      male: 'create_account_male_' + this.htmlId,
      female: 'create_account_female_' + this.htmlId,
      trans: 'create_account_trans_' + this.htmlId,
      agreement: 'create_account_agreement_' + this.htmlId,
      save: 'create_account_save_' + this.htmlId,
      country: 'create_account_country_' + this.htmlId,
      first_name: 'create_account_name_' + this.htmlId + '_m'
    };
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.mandatoryLanguages.push(this.localService.getSelectedLanguageId());
  }

  ngOnChanges(): void {
    setTimeout(() => { //To avoid NG0100 error
      if (this.isOpenPopup) {
        this.onReset();
        this.onLoad();
        this.offcanvasService.open(this.content, {
          position: 'end',
          backdrop: 'static',
          keyboard: false,
          animation: true,
          panelClass: 'popup_overlay_right',
          beforeDismiss: this.onBeforeDismiss
        });
      }
    }, 0);
  }

  onBeforeDismiss(): boolean {
    this.PhoneNumber = '';
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onCloseTrigger(event?: any) {
    if (this.btnIdToTriggerWhileClose) {
      let element: HTMLButtonElement = document.getElementById(this.btnIdToTriggerWhileClose) as HTMLButtonElement;
      if (element) {
        this.localService.dataWhileClosingPopupAndTriggerButton = event;
        element.click();
      }
    }
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  ngAfterViewInit() {
    if (this.BusinessId != '') {
      this.onCheckGender(1);
    }
    this.onCheckReference();
  }

  onCheckGender(gender: number) {
    setTimeout(() => {
      switch (gender) {
        case 1: {
          let element: HTMLInputElement = document.getElementById(this.elementIds.male) as HTMLInputElement;
          if (element) { element.click(); }
        } break;
        case 2: {
          let element: HTMLInputElement = document.getElementById(this.elementIds.female) as HTMLInputElement;
          if (element) { element.click(); }
        } break;
        case 3: {
          let element: HTMLInputElement = document.getElementById(this.elementIds.trans) as HTMLInputElement;
          if (element) { element.click(); }
        } break;
      }
    }, 500);
  }

  onCheckReference() {
    let item: KeyValueSet = this.onGetReference();
    if (item) {
      this.profileManagementService.getMemberName(item.key, item.value, false).subscribe(result => {
        this.refMember = result;
      });
    }
  }

  onGetReference(): KeyValueSet {
    let item: KeyValueSet;
    if (this.localService.redirectUrl != '' && this.localService.redirectUrl.startsWith(this.localService.referencePrefix)) {
      let values = this.localService.redirectUrl.split('-');
      item = { key: values[1], value: values[2] } as KeyValueSet;
    }
    return item;
  }

  onOtpVerified(e) {
    this.isOtpVerifiedForEdit = true;
    this.onSaveMember();
  }

  onContactUpdated(e) {
    this.selectedContact = e;
    this.localService.selected.countryCode = this.selectedContact.v2;
    this.PhoneNumber = this.selectedContact.v5;
    this.wrapper.content.v2 = this.selectedContact.key;
    if (this.selectedContact.isReadonly) {
      this.localService.onFocusNextInput(this.elementIds.first_name, FocusInputType.TextBox);
    }
  }

  onLoad() {

    this.isAgreementClicked = this.localService.selected && this.localService.selected.user ? true : false;

    if (this.BusinessId != '') {
      this.isAgreementClicked = true;
      this.wrapper.content = {
        v8: this.isSetFromLogin ? this.localService.loggedMember.loggedMember.content.v8 : ''
      } as KeyValues10;
    }
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.countryManagementService.ensureCountryCodes();
    if (this.id && this.id != '') {
      this.isAddNewAddress = false;
      this.profileManagementService.getMember(this.id).subscribe(result => {
        this.wrapper = result;
        this.phoneNumberBeforeEdit = this.wrapper.content.v9;
        this.PhoneNumber = this.wrapper.content.v9;
        this.onCheckGender(parseInt(this.wrapper.content.v7));
        //setTimeout(() => {
        //  this.localService.onFocusNextInput(this.elementIds.ph_num, FocusInputType.TextBox);
        //}, 100);
      });
    } else {
      this.isAddNewAddress = true;
      this.wrapper.content = { key: '', v1: '', v2: '', v9: this.PhoneNumber, v7: '0', v8: this.isSetFromLogin ? this.localService.loggedMember.loggedMember.content.v8 : '', v3: '' } as KeyValues10;
    }
    if (this.isSetFromLogin) {
      this.localService.onFocusNextInput(this.elementIds.first_name, FocusInputType.TextBox);
    }
  }

  onGenderCheked(value) {
    this.wrapper.content.v7 = value;
    this.localService.onFocusNextInput(this.elementIds.postal, FocusInputType.TextBox);
  }

  onPopupSave() {
    this.wrapper.content.v9 = this.PhoneNumber;
    this.wrapper.content.v10 = this.BusinessId;
    this.wrapper.content.v3 = this.localService.selected.applicationLanguage;
    if (this.doCheck()) {
      this.onSaveMember();
    }
  }

  onSaveMember() {
    this.profileManagementService.saveMember(this.wrapper, this.onGetReference()).subscribe(result => {
      switch (result.status) {
        case Status.NotAllowed:
        case Status.Success: {
          this.onSaveAddress(result.id);
          if (this.localService.redirectUrl && this.localService.redirectUrl.startsWith("ref-")) {
            this.localService.redirectUrl = '';
          }
          if (!this.localService.selected.user) {
            this.localService.setLastUser(result.id, this.wrapper.content.v9);
            this.localService.onFocusNextInput('btn_login_logout', FocusInputType.Button, true);
          }
          this.onCloseTrigger({ event: TriggeredEvent.Ok, data: this.wrapper.content.v9, ctryCode: this.localService.selected.countryCode, phoneNumber: this.wrapper.content.v9, status: result.status });
        } break;
        case Status.Duplicate: {
          this.message = this.localService.languageContent.create_account.account_exists;
        } break;
        case Status.NeedConfirmation: {
          const modalRef = this.modalService.open(MessageComponent);
          modalRef.componentInstance.IsConfirmationType = true;
          modalRef.componentInstance.message = this.localService.languageContent.create_account.overwrite_phonenum;
          modalRef.result.then((result) => {
            if (result.event == TriggeredEvent.Ok) {
              this.wrapper.content.v1 = '1';
              this.onSaveMember();
            }
            else
              this.onCloseTrigger({ event: TriggeredEvent.Close });
          }, (error) => {
            this.onCloseTrigger({ event: TriggeredEvent.Close });
          });
        } break;
      }
    });
  }

  onSaveAddress(userId: string) {
    if (this.isAddNewAddress && this.address?.trim().length > 0) {
      this.isAddNewAddress = false;
      if (!(this.addressTitle?.trim().length > 0)) {
        this.addressTitle = 'Delivery Address';
      }
      const newAddress = {
        key: userId,
        v2: this.addressTitle?.trim() ?? '',
        v3: this.address?.trim() ?? ''
      } as KeyValues3;
      this.profileManagementService.saveDeliveryAddess(newAddress).subscribe(result => {
      });
    }
  }

  onReset() {
    this.numericConfig.maxDigits = this.localService.getPostalCodeMaxDigitByCountryCode(this.localService.getLoginAsCountryCode() );
    this.isAlphaNumericPostalCode = this.localService.getIsAlphaNumericPostalCodeByCountryCode(this.localService.getLoginAsCountryCode() );
    this.isOtpVerifiedForEdit = null;
    this.wrapper = {
      localLocations: { v3: '', v2: '', v1: '' } as KeyValues3,
      content: { key: '', v1: '', v2: '', v9: null, v7: '0', v8: this.isSetFromLogin ? this.localService.loggedMember.loggedMember.content.v8 : '', v3: '' } as KeyValues10,
      languageNames: null,
      languageNamesShort: null
    }
    this.isAgreementClicked = false;
    this.states = null;
    this.districts = null;
    this.constituencies = null;
    this.message = '';
    this.isRedAlert = true;
    if (this.wrapper.content.v9 == null || this.wrapper.content.v9 == '')
      this.localService.onFocusNextInput(this.elementIds.ph_num, FocusInputType.TextBox);
    else
      this.localService.onFocusNextInput(this.elementIds.first_name, FocusInputType.TextBox);
  }

  doCheck() {
    let message = '';
    this.isOtpVerifiedForEdit = null;
    this.wrapper.content.v8 = this.wrapper.content.v8.toString().trim();
    if (this.wrapper.content.v2 == '') {
      message = this.localService.languageContent.create_account.need_country;
      this.localService.onFocusNextInput(this.elementIds.country, FocusInputType.NgxDropDown);
    } else if (this.wrapper.content.v9 == null || this.wrapper.content.v9 == '') {
      message = this.localService.languageContent.create_account.need_phone_number;
      this.localService.onFocusNextInput(this.elementIds.ph_num, FocusInputType.TextBox);
    } else if (!this.selectedContact.isReadonly) {
      message = this.localService.languageContent.create_account.need_valid_ph_num;
      this.localService.onFocusNextInput(this.elementIds.ph_num, FocusInputType.TextBox, true);
    } else if (!this.wrapper.languageNames || this.wrapper.languageNames.filter(x => x.v3 != '').length == 0) {
      message = this.localService.languageContent.create_account.need_name;
      this.localService.onFocusNextInput(this.elementIds.first_name, FocusInputType.TextBox);
    } else /* if (this.wrapper.localLocations.v3 != undefined && this.wrapper.localLocations.v3 != null && this.wrapper.localLocations.v3 == '') {
      message = this.localService.languageContent.create_account.need_state;
      this.localService.onFocusNextInput(this.elementIds.state, FocusInputType.NgxDropDown);
    } else if (this.wrapper.localLocations.v2 != undefined && this.wrapper.localLocations.v2 != null && this.wrapper.localLocations.v2 == '') {
      message = this.localService.languageContent.create_account.need_district;
      this.localService.onFocusNextInput(this.elementIds.district, FocusInputType.NgxDropDown);
    } else if (this.wrapper.localLocations.v1 != undefined && this.wrapper.localLocations.v1 != null && this.wrapper.localLocations.v1 == '') {
      message = this.localService.languageContent.create_account.need_constituency;
      this.localService.onFocusNextInput(this.elementIds.constituency, FocusInputType.NgxDropDown);
    } else if (!this.wrapper.content.v7 || this.wrapper.content.v7 == '' || this.wrapper.content.v7 == '0') {
      message = this.localService.languageContent.create_account.need_gender;
    } else if (this.wrapper.content.v8 == '') {
        message = this.localService.languageContent.create_account.need_postalCode;
        this.localService.onFocusNextInput(this.elementIds.postal, FocusInputType.TextBox);
      } else if (this.numericConfig.maxDigits > 0 && this.wrapper.content.v8.toString().length != this.numericConfig.maxDigits) {
        message = this.localService.languageContent.create_account.need_valid_postalCode;
        this.localService.onFocusNextInput(this.elementIds.postal, FocusInputType.TextBox);
      } else */ if (this.id == '' && !this.isAgreementClicked) {
        message = this.localService.languageContent.create_account.need_agreement;
      } else if (!this.isOtpVerifiedForEdit) {
        if (this.id == '')
          this.isOtpVerifiedForEdit = true;
        else if (this.phoneNumberBeforeEdit != this.PhoneNumber)
          this.isOtpVerifiedForEdit = false;
        else
          this.isOtpVerifiedForEdit = true;
      }
    this.message = message;
    return message == '' && this.isOtpVerifiedForEdit;
  }

  onLocationUpdated(e) {
    this.wrapper.localLocations = e;
  }

  onEmptyLanguageContainerAdded(languageContents: any, index: number) {
    switch (index) {
      case 1: {
        this.wrapper.languageNames = languageContents;
      } break;
      case 2: {
        this.wrapper.languageNamesShort = languageContents;
      } break;
    }
  }
}
